import { visitTemplatesTranslationKeys } from '../../../translations';
import { VisitTemplateFormController } from '../VisitTemplateForm.types';

import { VisitTemplateFormTextEditor } from './VisitTemplateFormTextEditor';

type VisitTemplateFormInterviewProps = Pick<VisitTemplateFormController, 'register' | 'control'>;

export const VisitTemplateFormInterviewTextarea = (props: VisitTemplateFormInterviewProps): JSX.Element => {
   return (
      <VisitTemplateFormTextEditor
         register={props.register}
         control={props.control}
         fieldName={'interview'}
         label={visitTemplatesTranslationKeys.interview}
         placeholder={visitTemplatesTranslationKeys.enterInterview}
         testId={'interview'}
      />
   );
};
